/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_How_IntroInputs */

const es_l7_how_intro = /** @type {(inputs: L7_How_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin convertirte en administrador náutico a tiempo parcial. Sin letra pequeña.`)
};

const gl_l7_how_intro = /** @type {(inputs: L7_How_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sen converterte en administrador náutico a tempo parcial. Sen letra pequena.`)
};

const en_l7_how_intro = /** @type {(inputs: L7_How_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without becoming a part-time nautical administrator. No fine print.`)
};

/**
* | output |
* | --- |
* | "Without becoming a part-time nautical administrator. No fine print." |
*
* @param {L7_How_IntroInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_how_intro = /** @type {((inputs?: L7_How_IntroInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_How_IntroInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_how_intro(inputs)
	if (locale === "en") return en_l7_how_intro(inputs)
	return es_l7_how_intro(inputs)
});